(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();

    this.slider = {};
    this.controls = null;
    this.shouldDestroyOnDesktop = this.hasAttribute('data-destroy');
    this.breakpoints = {
      desktop: 990
    };
    this.controls = this.querySelectorAll('[data-control]');
    if (this.controls) { 
      this.controls.forEach(control => control.addEventListener('click', this.onControlClick.bind(this)));
      window.addEventListener("resize", this.showArrows.bind(this));
    }
      
    }
    connectedCallback() {
      this.initSlider();
    }

  initSlider() {
    const sliderList = this.querySelector('.splide');

    if (!sliderList) return;    
          
    this.slider = new Splide(this.querySelector('.splide'), {
      trimSpace: 'move',
      waitForTransition: false,
      flickMaxPages: 0.5,
      gap: '29px',
      perPage: 4,
      perMove: 1,
      pagination: false,
      drag: this.querySelectorAll('.splide__slide').length > 4 ? true : false,
      arrows: false,
      type: 'slide',
      breakpoints: {
        [this.breakpoints.desktop]: {
          perPage: 2,
          drag: this.querySelectorAll('.splide__slide').length > 2 ? true : false,
        }
      }
    });
      
    this.slider.mount();    
    this.showArrows();
  }
    
    showArrows() { 
    this.controls = this.querySelectorAll('[data-control]');
    if (!this.controls) return;
    this.controls.forEach((control) => {
      if (window.innerWidth >= this.breakpoints.desktop) {
        if (this.querySelectorAll('.splide__slide').length > 4) {
          control.classList.remove('hidden')
        } else control.classList.add('hidden')
        }
        
      if (window.innerWidth < this.breakpoints.desktop) { 
        if (this.querySelectorAll('.splide__slide').length > 2) { 
          control.classList.remove('hidden')
        } else control.classList.add('hidden')
      }         
    });
  }

  onControlClick(event) {
  event.preventDefault();

  if (this.slider === {}) {
    return;
  }

  const action = event.target.closest('button').hasAttribute('data-prev') ? '<' : '>';
  this.slider.go(action);
  }
}

  customElements.define('products-carousel', ProductsCarousel);
})();